const React = require('react');
const { createElement: h, useEffect, useRef, useState } = React;
const { request, getApiBasePath, getAccessToken } = require('../lib/apiClient');
const { openGoogleScopePicker } = require('../lib/googleScopePicker');
const {
  providerAccountsFingerprint,
  getProviderAccountsFingerprint
} = require('../lib/oauthConnect');
const ConfirmDialog = require('./ConfirmDialog');

// `user.connectedAccounts[provider]` is now an array of credential summaries
// (see authService.summarizeCredential). This helper tolerates the legacy
// single-object shape for users that haven't been migrated yet — wraps the
// non-empty single object into a 1-element array so the rest of the component
// only deals with arrays.
function getAccountList(user, provider) {
  var accounts = user && user.connectedAccounts ? user.connectedAccounts : {};
  var raw = accounts && accounts[provider];
  if (Array.isArray(raw)) return raw;
  if (raw && typeof raw === 'object' && (raw.connected || raw.connectedAt)) {
    return [{
      id: '',
      label: (raw.account && (raw.account.email || raw.account.teamName || raw.account.username || raw.account.name)) || '',
      scopes: Array.isArray(raw.scopes) ? raw.scopes : [],
      account: raw.account || {},
      connectedAt: raw.connectedAt || null,
      updatedAt: raw.updatedAt || null
    }];
  }
  return [];
}

function GoogleIcon() {
  return h('svg', { className: 'cap-provider-icon', width: 24, height: 24, viewBox: '0 0 24 24' },
    h('path', { d: 'M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z', fill: '#4285F4' }),
    h('path', { d: 'M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z', fill: '#34A853' }),
    h('path', { d: 'M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z', fill: '#FBBC05' }),
    h('path', { d: 'M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z', fill: '#EA4335' })
  );
}

function MicrosoftIcon() {
  return h('svg', { className: 'cap-provider-icon', width: 24, height: 24, viewBox: '0 0 24 24' },
    h('rect', { x: 1, y: 1, width: 10.5, height: 10.5, fill: '#F25022' }),
    h('rect', { x: 12.5, y: 1, width: 10.5, height: 10.5, fill: '#7FBA00' }),
    h('rect', { x: 1, y: 12.5, width: 10.5, height: 10.5, fill: '#00A4EF' }),
    h('rect', { x: 12.5, y: 12.5, width: 10.5, height: 10.5, fill: '#FFB900' })
  );
}

function ShopifyIcon() {
  return h('svg', { className: 'cap-provider-icon', width: 24, height: 24, viewBox: '0 0 24 24' },
    h('path', { d: 'M5.1 6.7 6.5 4.9c.5-.1 1-.2 1.5-.3C8.4 2 9.7.5 11.4.5c1.9 0 2.8 1.8 3.1 3.2l2.4.7c.2.1.3.2.3.4L19 20.9 7 23.5 4.3 7.2c0-.2.2-.4.4-.4l.4-.1Zm3.9-2.3 3.7-.5c-.2-1-.7-1.9-1.4-1.9-1 0-1.9.9-2.3 2.4Zm-1.2.2c.4-1.3 1-2.3 1.8-3-.8.2-1.5 1.3-1.9 3h.1Z', fill: '#95BF47' }),
    h('path', { d: 'M14.8 8.1c-.5-.3-1.2-.4-1.8-.4-1.5 0-1.6.9-1.6 1.1 0 1.2 3.2 1.7 3.2 4.6 0 2.3-1.4 3.8-3.4 3.8-2.3 0-3.5-1.5-3.5-1.5l.6-2.1s1.2 1.1 2.3 1.1c.7 0 1-.6 1-.9 0-1.6-2.6-1.7-2.6-4.3 0-2.2 1.6-4.4 4.9-4.4 1.3 0 1.9.4 1.9.4l-1 2.6Z', fill: '#fff' })
  );
}

function SlackIcon() {
  return h('svg', { className: 'cap-provider-icon', width: 24, height: 24, viewBox: '0 0 24 24' },
    h('path', { d: 'M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313z', fill: '#E01E5A' }),
    h('path', { d: 'M8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312z', fill: '#36C5F0' }),
    h('path', { d: 'M18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312z', fill: '#2EB67D' }),
    h('path', { d: 'M15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z', fill: '#ECB22E' })
  );
}

function AtlassianIcon() {
  return h('svg', { className: 'cap-provider-icon', width: 24, height: 24, viewBox: '0 0 24 24' },
    h('defs', null,
      h('linearGradient', { id: 'atl-grad-a', x1: '50%', y1: '100%', x2: '50%', y2: '0%' },
        h('stop', { offset: '0%', stopColor: '#0052CC' }),
        h('stop', { offset: '100%', stopColor: '#2684FF' })
      )
    ),
    h('path', { d: 'M6.65 11.13c-.21-.22-.55-.21-.71.05L.1 22.83a.5.5 0 0 0 .45.72h8.06c.26 0 .49-.15.6-.39 1.74-3.59.69-9.05-2.56-12.03z', fill: 'url(#atl-grad-a)' }),
    h('path', { d: 'M11.53.27a11.4 11.4 0 0 0-.66 11.27l3.93 7.86c.11.23.34.38.6.38h8.06a.5.5 0 0 0 .45-.72S12.93.79 12.65.28c-.16-.27-.51-.27-.67-.01-.05.07-.36.7-.45 0z', fill: '#2684FF' })
  );
}

function UnicontaIcon() {
  // Uniconta has no inline SVG mark like the others; use the brand logo image.
  return h('img', {
    className: 'cap-provider-icon',
    width: 24,
    height: 24,
    alt: 'Uniconta',
    src: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRi-q_UrOZBwjkxw1RsPN3-JwZocT7X_NEaXOE7hfw6yw&s=10'
  });
}

function formatConnectedAt(value) {
  if (!value) return '';
  var date = new Date(value);
  if (!Number.isFinite(date.getTime())) return '';
  return date.toLocaleString();
}

// Per-provider OAuth flow config. Add a new provider here and the rest of
// this component (handleConnect, message listener, watchPopupClose) wires up
// automatically — no other edits needed.
var PROVIDER_CONFIG = {
  google: {
    label: 'Google',
    urlEndpoint: '/google-auth/url',
    popupName: 'google-auth',
    // Google opens a scope-picker modal first (name + permission selection)
    // before the OAuth window — see GoogleScopePickerModal.
    scopePicker: true
  },
  microsoft: {
    label: 'Microsoft',
    urlEndpoint: '/microsoft-auth/url',
    popupName: 'microsoft-auth'
  },
  shopify: {
    label: 'Shopify',
    pagePopup: true,
    popupName: 'shopify-auth',
    pagePath: '/shopify-auth/connect-page'
  },
  slack: {
    label: 'Slack',
    urlEndpoint: '/slack-auth/url',
    popupName: 'slack-auth',
    // Slack auto-picks the workspace you're already signed into and skips the
    // chooser. Surface a "sign out first" link so users connecting a different
    // workspace can clear that session before opening the OAuth popup.
    signOutUrl: 'https://my.slack.com/account/settings#sign_out_all_sessions',
    signOutLabel: 'Sign out of other Slack workspaces first'
  },
  atlassian: {
    label: 'Atlassian',
    urlEndpoint: '/atlassian-auth/url',
    popupName: 'atlassian-auth'
  },
  // Uniconta is NOT OAuth, but it connects via a popup WINDOW like the others:
  // the popup loads a server-served credentials form (Company ID + API user +
  // password) that POSTs to /uniconta-auth/connect and postMessages back the
  // same `uniconta-auth-success` event. `pagePopup: true` marks this variant.
  uniconta: {
    label: 'Uniconta',
    pagePopup: true,
    popupName: 'uniconta-auth',
    pagePath: '/uniconta-auth/connect-page'
  }
};

function providerLabel(provider) {
  return (PROVIDER_CONFIG[provider] && PROVIDER_CONFIG[provider].label) || provider;
}

// Pull the best display name for one credential. The backend stores `label`
// on the credential, but legacy rows may not have one — fall back to fields
// inside `account` that the OAuth callback populated.
function credentialDisplayName(credential, provider) {
  if (!credential) return providerLabel(provider) + ' account';
  if (credential.label) return credential.label;
  var account = credential.account || {};
  return account.email
    || account.username
    || account.teamName
    || account.userName
    || account.shop
    || account.name
    || (providerLabel(provider) + ' account');
}

function ConnectedAccountsPage(props) {
  var user = props && props.user ? props.user : null;
  var onRefreshUser = props && props.onRefreshUser ? props.onRefreshUser : null;
  var [accounts, setAccounts] = useState(function() {
    return {
      google: getAccountList(user, 'google'),
      microsoft: getAccountList(user, 'microsoft'),
      shopify: getAccountList(user, 'shopify'),
      slack: getAccountList(user, 'slack'),
      atlassian: getAccountList(user, 'atlassian'),
      uniconta: getAccountList(user, 'uniconta')
    };
  });
  var [pendingProvider, setPendingProvider] = useState('');
  var [removingId, setRemovingId] = useState('');
  var [confirmDisconnect, setConfirmDisconnect] = useState(null); // { provider, credentialId, displayName }
  var [message, setMessage] = useState('');
  var popupTimerRef = useRef(null);

  function clearPopupTimer() {
    if (popupTimerRef.current) {
      clearInterval(popupTimerRef.current);
      popupTimerRef.current = null;
    }
  }

  function refreshConnectedProvider(provider) {
    setMessage(providerLabel(provider) + ' account connected.');
    if (typeof onRefreshUser === 'function') {
      onRefreshUser().catch(function(refreshError) {
        console.warn('Failed to refresh user after ' + provider + ' connect:', refreshError);
      });
    }
  }

  useEffect(function() {
    setAccounts({
      google: getAccountList(user, 'google'),
      microsoft: getAccountList(user, 'microsoft'),
      shopify: getAccountList(user, 'shopify'),
      slack: getAccountList(user, 'slack'),
      atlassian: getAccountList(user, 'atlassian'),
      uniconta: getAccountList(user, 'uniconta')
    });
  }, [user && user.id, user && user.connectedAccounts]);

  useEffect(function() {
    function handleMessage(event) {
      var data = event && event.data;
      if (!data || typeof data !== 'object' || typeof data.type !== 'string') return;
      var successMatch = data.type.match(/^([a-z]+)-auth-success$/);
      var errorMatch = data.type.match(/^([a-z]+)-auth-error$/);

      if (successMatch) {
        var successProvider = successMatch[1];
        clearPopupTimer();
        setPendingProvider('');
        // Refresh the full user payload so the new credential's id + label
        // come from the server (we don't try to reconstruct them client-side).
        refreshConnectedProvider(successProvider);
        return;
      }

      if (errorMatch) {
        var errorProvider = errorMatch[1];
        clearPopupTimer();
        setPendingProvider('');
        setMessage(data.error ? String(data.error) : (providerLabel(errorProvider) + ' connection failed.'));
      }
    }
    window.addEventListener('message', handleMessage);
    return function() { window.removeEventListener('message', handleMessage); };
  }, [onRefreshUser]);

  useEffect(function() {
    return function() { clearPopupTimer(); };
  }, []);

  function watchPopupClose(popup, provider, baselineFingerprint) {
    clearPopupTimer();
    if (!popup) return;
    var checkingServer = false;
    popupTimerRef.current = setInterval(function() {
      if (popup.closed && !checkingServer) {
        checkingServer = true;
        clearPopupTimer();
        getProviderAccountsFingerprint(provider).then(function(currentFingerprint) {
          setPendingProvider(function(current) {
            if (current === provider) {
              if (currentFingerprint !== baselineFingerprint) {
                refreshConnectedProvider(provider);
              } else {
                setMessage(providerLabel(provider) + ' connection did not complete.');
              }
              return '';
            }
            return current;
          });
        }).catch(function() {
          setPendingProvider(function(current) {
            if (current === provider) {
              setMessage('Could not confirm the ' + providerLabel(provider) + ' connection. Refresh this page to check it.');
              return '';
            }
            return current;
          });
        });
      }
    }, 600);
  }

  function handleConnect(provider) {
    setMessage('');
    var cfg = PROVIDER_CONFIG[provider];
    if (!cfg) {
      setMessage(providerLabel(provider) + ' login is not configured yet.');
      return;
    }

    // Page-popup providers (Uniconta) open a popup window that loads a
    // server-served credentials form directly — no OAuth /url round-trip. The
    // SPA access token is passed in the URL hash so the in-popup fetch can
    // authenticate its POST. The popup postMessages `uniconta-auth-success`
    // back, handled by the same listener as the OAuth providers.
    if (cfg.pagePopup) {
      var token = getAccessToken();
      var pageUrl = getApiBasePath() + cfg.pagePath + '#token=' + encodeURIComponent(token || '');
      var baselineFingerprint = providerAccountsFingerprint(accounts[provider] || []);
      setPendingProvider(provider);
      var pagePopup = window.open(pageUrl, cfg.popupName, 'width=480,height=560,left=200,top=100');
      if (!pagePopup) {
        setPendingProvider('');
        setMessage('Popup was blocked. Please allow popups for this site and try again.');
        return;
      }
      watchPopupClose(pagePopup, provider, baselineFingerprint);
      return;
    }

    // Google requires the user to name the connection + pick permissions first.
    // The shared scope-picker (mounted once at the app root) collects those,
    // then we start the OAuth popup with the chosen name + scopes as query
    // params. All other OAuth providers connect directly.
    if (cfg.scopePicker) {
      openGoogleScopePicker().then(
        function(selection) {
          var query = 'name=' + encodeURIComponent(selection.name) +
            '&scopes=' + encodeURIComponent((selection.scopes || []).join(','));
          startOAuthFlow(provider, query);
        },
        function() { /* cancelled — nothing to do */ }
      );
      return;
    }

    startOAuthFlow(provider, '');
  }

  // Open the OAuth popup for an /url-based provider. `queryString` (optional)
  // carries provider-specific params, e.g. Google's name + selected scopes.
  function startOAuthFlow(provider, queryString) {
    var cfg = PROVIDER_CONFIG[provider];
    if (!cfg) return;
    var baselineFingerprint = providerAccountsFingerprint(accounts[provider] || []);
    setPendingProvider(provider);
    var popup = null;
    try {
      popup = window.open('', cfg.popupName, 'width=520,height=650,left=200,top=100');
    } catch (error) {
      popup = null;
    }
    request(cfg.urlEndpoint + (queryString ? ('?' + queryString) : ''))
      .then(function(result) {
        if (result && result.url) {
          if (popup && !popup.closed) {
            popup.location.href = result.url;
          } else {
            popup = window.open(result.url, cfg.popupName, 'width=520,height=650,left=200,top=100');
          }
          if (!popup) {
            setPendingProvider('');
            setMessage('Popup was blocked. Please allow popups for this site and try again.');
            return;
          }
          watchPopupClose(popup, provider, baselineFingerprint);
          return;
        }
        if (popup && !popup.closed) popup.close();
        setPendingProvider('');
        setMessage('Could not start ' + cfg.label + ' login.');
      })
      .catch(function(error) {
        if (popup && !popup.closed) popup.close();
        setPendingProvider('');
        setMessage(error && error.message ? error.message : 'Could not start ' + cfg.label + ' login.');
      });
  }

  function handleDisconnect(provider, credentialId, displayName) {
    if (!credentialId) {
      setMessage('This connection was created before multi-account support shipped. Reconnect to get a removable entry.');
      return;
    }
    setConfirmDisconnect({ provider: provider, credentialId: credentialId, displayName: displayName });
  }

  function performDisconnect(provider, credentialId) {
    setRemovingId(credentialId);
    request('/connected-accounts/' + encodeURIComponent(provider) + '/' + encodeURIComponent(credentialId), { method: 'DELETE' })
      .then(function() {
        setMessage(providerLabel(provider) + ' account removed.');
        if (typeof onRefreshUser === 'function') {
          return onRefreshUser();
        }
      })
      .catch(function(error) {
        setMessage(error && error.message ? error.message : 'Failed to disconnect.');
      })
      .then(function() { setRemovingId(''); });
  }

  // One credential row inside a provider section.
  function renderCredentialRow(provider, credential) {
    var displayName = credentialDisplayName(credential, provider);
    var connectedAt = formatConnectedAt(credential.connectedAt);
    var isRemoving = removingId && removingId === credential.id;
    return h('div', { key: credential.id || displayName, className: 'cap-cred-row' },
      h('div', { className: 'cap-cred-row__text' },
        h('div', { className: 'cap-cred-row__label' }, displayName),
        connectedAt ? h('div', { className: 'cap-cred-row__meta' }, 'Connected ' + connectedAt) : null
      ),
      h('button', {
        className: 'cap-cred-row__remove',
        type: 'button',
        disabled: isRemoving || !credential.id,
        title: credential.id ? 'Disconnect this account' : 'Legacy connection — reconnect first',
        onClick: function() { handleDisconnect(provider, credential.id, displayName); }
      }, isRemoving ? 'Removing...' : 'Disconnect')
    );
  }

  function renderProviderCard(provider, label, icon, description) {
    var list = accounts[provider] || [];
    var pending = pendingProvider === provider;
    var cfg = PROVIDER_CONFIG[provider] || {};
    var hasAny = list.length > 0;

    return h('article', { className: 'cap-card', key: provider },
      h('div', { className: 'cap-card__main' },
        h('div', { className: 'cap-card__icon' }, icon),
        h('div', { className: 'cap-card__text' },
          h('div', { className: 'cap-card__header' },
            h('h2', { className: 'cap-card__title' }, label),
            h('span', { className: 'cap-status' + (hasAny ? ' cap-status--connected' : '') },
              hasAny ? (list.length + ' connected') : 'Not connected'
            )
          ),
          h('p', { className: 'cap-card__description' }, description),
          cfg.signOutUrl ? h('p', { className: 'cap-card__meta' },
            h('a', {
              href: cfg.signOutUrl,
              target: '_blank',
              rel: 'noopener noreferrer'
            }, cfg.signOutLabel || ('Sign out of ' + (cfg.label || provider) + ' first')),
            ' (open in a new tab if you want to connect a different account)'
          ) : null,
          hasAny ? h('div', { className: 'cap-cred-list' },
            list.map(function(cred) { return renderCredentialRow(provider, cred); })
          ) : null
        )
      ),
      h('button', {
        className: 'cap-connect-btn',
        type: 'button',
        disabled: pending,
        onClick: function() { handleConnect(provider); }
      }, pending ? 'Opening...' : (hasAny ? 'Connect another' : 'Connect'))
    );
  }

  return h('main', { className: 'cap-root' },
    confirmDisconnect
      ? h(ConfirmDialog, {
          title: 'Disconnect account?',
          message: 'Disconnect ' + confirmDisconnect.displayName + '? Workflow nodes pinned to this account will fail until you pick another.',
          confirmLabel: 'Disconnect',
          cancelLabel: 'Cancel',
          danger: true,
          onConfirm: function() {
            var target = confirmDisconnect;
            setConfirmDisconnect(null);
            performDisconnect(target.provider, target.credentialId);
          },
          onCancel: function() { setConfirmDisconnect(null); }
        })
      : null,
    h('header', { className: 'cap-header' },
      h('p', { className: 'cap-eyebrow' }, 'User account'),
      h('h1', { className: 'cap-title' }, 'Connected accounts'),
      h('p', { className: 'cap-copy' }, 'Connect multiple accounts per provider. In a workflow node’s Settings panel, pick which account that specific node uses — nodes without a selection fall back to your first connected account.')
    ),
    h('section', { className: 'cap-list' },
      renderProviderCard('google', 'Google', h(GoogleIcon), 'Use Gmail, Calendar, and Drive from workflow nodes through any of your saved Google accounts.'),
      renderProviderCard('microsoft', 'Microsoft', h(MicrosoftIcon), 'Use Outlook Mail, Calendar, and OneDrive from workflow nodes through any of your saved Microsoft accounts.'),
      renderProviderCard('shopify', 'Shopify', h(ShopifyIcon), 'Read and manage store data from workflow nodes through any of your connected Shopify stores.'),
      renderProviderCard('slack', 'Slack', h(SlackIcon), 'Post to channels, read history, and message users from workflow nodes through any of your saved Slack workspaces.'),
      renderProviderCard('atlassian', 'Atlassian', h(AtlassianIcon), 'Create Jira issues, update Confluence pages, and read tickets from workflow nodes through any of your saved Atlassian accounts.'),
      renderProviderCard('uniconta', 'Uniconta', h(UnicontaIcon), 'Read and write Uniconta ERP data (debtors, creditors, invoices, orders, inventory) from workflow nodes. Connect with your Company ID and API user — each connection is tied to one company.')
    ),
    message ? h('div', { className: 'wlp-toast' }, message) : null
  );
}

module.exports = ConnectedAccountsPage;
